import axiosInstance from './axiosInstance';

// Create a new user
export const createUser = (data) => axiosInstance.post('/user/create', data);

// Get authenticated user details
export const getUserDetails = () => axiosInstance.get('/user/me');

// Get user by ID
export const getUserById = (id) => axiosInstance.get(`/user/${id}`);

// Update user details by ID
export const updateUserDetails = (id, data) =>
	axiosInstance.put(`/user/update/${id}`, data);

// Get users by company ID
export const getUsersByCompany = (companyId) =>
	axiosInstance.get(`/user/company/${companyId}`);

// Get users by role
export const getUsersByRole = (role) => axiosInstance.get(`/user/role/${role}`);

// Get all users
export const getAllUsers = () => axiosInstance.get('/user');

// Delete user by ID
export const deleteUser = (id) => axiosInstance.delete(`/user/${id}`);

// Update user permissions
export const updateUserPermissions = (id, { permissions, changedUniqueKey } = {}) =>
	axiosInstance.put(`/user/users/${id}/permissions`, {
		permissions,
		changedUniqueKey,
	});

// Promote employee to company administrator
export const promoteToCompanyAdmin = (id) =>
	axiosInstance.put(`/user/${id}/promote-company-admin`);

// Demote company administrator to employee (company owner only)
export const demoteCompanyAdmin = (id) =>
	axiosInstance.put(`/user/${id}/demote-company-admin`);

// Suspend or restore a user account
export const setUserSuspension = (id, isSuspended) =>
	axiosInstance.put(`/user/${id}/suspension`, { isSuspended });
